import { useQuery } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";
import { MonitorData } from "./@types";

const fetchMonitor = async () => {
  const { data } = await apiInputService.get("/monitor/subscription");

  return data as MonitorData[];
};

export const useGetMonitorData = (options?: any) => {
  return useQuery<MonitorData[]>(["monitor"], () => fetchMonitor(), {
    ...options,
  });
};
